import { ModalProps } from "antd/lib/modal/Modal";
import { Col, InputNumber, message, Modal, Radio, Row, Spin } from "antd";
import styles from "./index.module.scss";
import React, {
    useContext,
    useEffect,
    useImperativeHandle,
    useReducer,
    useState
} from "react";
import useRequest from "../../../../../../utils/useRequest";
import {
    getChapterTemplateList,
    postTempProps,
    quoteChapterTemplate
} from "../../../../../../service/CourseDetail/chapter";
import Style from "./index.module.scss";
import QuoteTabItem from "./Components/QuoteTabItem";
import { CourseContext } from "../../../../Store";
import useCurrentDate from "../../../../../../utils/useCurrentDate";
import useRequestFn from "../../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
}

const initialState: postTempProps = {
    batchNo: "-1",
    chapterCount: 3,
    courseNo: "-1",
    courseSeq: "-1",
    id: -1,
    nodeCount: 3
};

function reducer(
    state: postTempProps,
    action: { type: keyof postTempProps; payload: string | number | undefined }
) {
    return {
        ...state,
        [action.type]: action.payload
    };
}

//id 1 2 3 4 按照顺序对应模版顺序
const A = ["", "章", "章", "周", "讲"];
const B = ["", "章", "章", "课时", ""];

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));

        const [params, dispatch] = useReducer(reducer, initialState);

        const [tempList, { loading }] = useRequest(
            () => getChapterTemplateList({}),
            {},
            []
        );

        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();
        useEffect(() => {
            dispatch({
                type: "id",
                payload: tempList?.[0].id
            });
            dispatch({
                type: "batchNo",
                payload: batchNo
            });
            dispatch({
                type: "courseNo",
                payload: course.courseNo
            });
            dispatch({
                type: "courseSeq",
                payload: course.courseSeq
            });
        }, [tempList]);

        useEffect(() => {
            if (params.id === 4) {
                dispatch({
                    type: "nodeCount",
                    payload: 0
                });
            }
        }, [params.id]);

        const [quoteAction, { loading: quoteLoading }] =
            useRequestFn(quoteChapterTemplate);

        async function onSubmit() {
            if (!params.chapterCount) {
                if (params.id !== 4 && !params.nodeCount) {
                    return message.warn("请输入预设章节数");
                }
            }
            try {
                await quoteAction(params);
                message.success("引用成功");
                onOk?.();
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                className={styles.root}
                onCancel={onCancel}
                maskClosable={false}
                title="引用章节"
                onOk={onSubmit}
                okButtonProps={{
                    loading: [quoteLoading, loading].some(i => i)
                }}>
                <Spin spinning={loading}>
                    <Row gutter={30} type="flex">
                        <Col span={6}>
                            <div className={Style.title}>章节模版</div>
                        </Col>
                        <Col span={15}>
                            <Row gutter={15} type="flex">
                                {tempList &&
                                    tempList.map(item => {
                                        return (
                                            <Col
                                                span={12}
                                                key={item.id}
                                                onClick={() => {
                                                    dispatch({
                                                        type: "id",
                                                        payload: item.id
                                                    });
                                                }}
                                                className={Style.col}>
                                                <QuoteTabItem
                                                    data={item}
                                                    active={
                                                        params.id === item.id
                                                    }>
                                                    <Radio
                                                        checked={
                                                            params.id ===
                                                            item.id
                                                        }
                                                        className={Style.radio}
                                                    />
                                                </QuoteTabItem>
                                            </Col>
                                        );
                                    })}
                            </Row>
                        </Col>
                        <Col span={6}>
                            <div className={Style.title}>预设章节数</div>
                        </Col>
                        <Col span={15}>
                            <div className={Style.inputRow}>
                                <div>
                                    共
                                    <InputNumber
                                        size="small"
                                        min={1}
                                        max={40}
                                        className={Style.num}
                                        value={params.chapterCount}
                                        onChange={value => {
                                            dispatch({
                                                type: "chapterCount",
                                                payload: value
                                            });
                                        }}
                                    />
                                    {A[params.id]}
                                </div>
                                {params.id !== 4 && (
                                    <div>
                                        ，每 {A[params.id]}
                                        <InputNumber
                                            size="small"
                                            min={1}
                                            max={40}
                                            className={Style.num}
                                            value={params.nodeCount}
                                            onChange={value => {
                                                dispatch({
                                                    type: "nodeCount",
                                                    payload: value
                                                });
                                            }}
                                        />
                                        {B[params.id]}
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Spin>
            </Modal>
        );
    }
);

export default DataModal;
